import React from "react";
import LoginForm from "../components/form/LoginForm";
import { LoginFormSubmit } from "../declarations/form";
import useUser from "../hook/useUser";
import useLoggedIn from "../hook/useLoggedIn";
import { DashboardLanguageButton } from "components/common/DashboardLocalization";

function LoginPage() {
  const { login } = useUser();

  useLoggedIn();

  const handleSubmit = (data: LoginFormSubmit) => {
    login(data);
  };

  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-slate-50 p-4">
      <DashboardLanguageButton className="fixed right-4 top-4 flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-100" />
      <LoginForm onSubmit={handleSubmit} />
    </main>
  );
}

export default LoginPage;
